import { useState } from "react";
import { Button, Field, SegmentedControl, Sheet, Textarea } from "@xinghai/ui";

export const SKIP_REASONS = [
  { value: "noisy", label: "现在环境太吵" },
  { value: "voice", label: "嗓子不舒服" },
  { value: "unfamiliar", label: "这条我读不准" },
  { value: "device", label: "设备有问题" },
  { value: "other", label: "其他原因" },
] as const;

export type SkipReason = (typeof SKIP_REASONS)[number]["value"];

export interface SkipSheetProps {
  open: boolean;
  busy?: boolean;
  onClose: () => void;
  onSubmit: (reason: SkipReason, note: string) => void;
}

/** docs/UX.md 2 —「跳过并说明原因」. A skipped task can be re-opened later. */
export function SkipSheet({ open, busy = false, onClose, onSubmit }: SkipSheetProps) {
  const [reason, setReason] = useState<SkipReason>("noisy");
  const [note, setNote] = useState("");

  return (
    <Sheet
      open={open}
      onClose={onClose}
      title="跳过这条，并告诉我们原因"
      size="md"
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={busy}>
            再想想
          </Button>
          <Button variant="primary" loading={busy} onClick={() => onSubmit(reason, note.trim())}>
            确认跳过
          </Button>
        </>
      }
    >
      <p className="gz-muted">跳过不会影响你的成绩，只是让老师知道这条为什么没录。</p>
      <Field label="原因">
        <SegmentedControl<SkipReason>
          label="跳过原因"
          vertical
          options={SKIP_REASONS.map((r) => ({ value: r.value, label: r.label }))}
          value={reason}
          onChange={setReason}
        />
      </Field>
      <Field label="想补充点什么？" hint="可以不填">
        <Textarea
          value={note}
          rows={3}
          maxLength={200}
          placeholder="比如：教室里正在装修"
          onChange={(e) => setNote(e.target.value)}
        />
      </Field>
    </Sheet>
  );
}
